import OriginalSelectInput from 'ink-select-input';
import type { FC, ReactNode } from 'react';

/**
 * Custom SelectInput component that wraps ink-select-input with type safety.
 */

export interface Item<V> {
  key?: string;
  label: string;
  value: V;
}

export interface IndicatorProps {
  isSelected?: boolean;
}

export interface ItemProps {
  isSelected?: boolean;
  label: string;
  // Used by SelectableTable. In that case, `label` might be used instead.
  index?: number;
}

interface Props<V> {
  indicatorComponent?: FC<IndicatorProps>;
  initialIndex?: number;
  isFocused?: boolean;
  itemComponent?: FC<ItemProps>;
  items?: Item<V>[];
  limit?: number;
  onHighlight?: (item: Item<V>) => void;
  onSelect?: (item: Item<V>) => void;
}

export default OriginalSelectInput as unknown as <V>(
  props: Props<V>,
) => ReactNode;
